import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Quote, Sparkles } from "lucide-react";
import { http } from "@/lib/api";

/**
 * A small homepage widget that rotates through the top-voted approved truths
 * with a per-UTC-day stable choice. Admin can customize copy through the
 * standard `content.section_truth_of_day` payload.
 */
export default function TruthOfTheDay({ c }) {
  const [truth, setTruth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get("/truth-wall/featured-of-the-day")
      .then(({ data }) => setTruth(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  // If there are no approved truths yet, hide the section entirely so the
  // homepage doesn't show an empty placeholder.
  if (loading) return null;
  if (!truth) return null;

  const eyebrow = c?.("truth_of_day", "eyebrow", "Truth Of The Day");
  const cta = c?.("truth_of_day", "cta_label", "Visit the Truth Wall");

  return (
    <section
      data-testid="truth-of-day"
      className="bg-[#050505] py-14 sm:py-20 border-y border-white/5"
    >
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="font-ui text-[10px] tracking-[0.32em] uppercase text-[#C9A055] mb-5 inline-flex items-center gap-2">
          <Sparkles size={11} /> {eyebrow}
        </div>
        <Quote size={28} className="mx-auto text-[#C9A055]/60 mb-4" />
        <blockquote className="font-display text-2xl sm:text-3xl lg:text-4xl text-[#F4F1EA] leading-[1.25]">
          &ldquo;{truth.text}&rdquo;
        </blockquote>
        <div className="mt-5 font-ui text-[11px] tracking-[0.22em] uppercase text-[#8a857d]">
          — {truth.name || "Anonymous"}
          {truth.city ? ` · ${truth.city}${truth.state ? `, ${truth.state}` : ""}` : ""}
        </div>
        <div className="mt-9 w-12 h-px bg-[#C9A055] mx-auto" />
        <div className="mt-7">
          <Link
            to="/truth-wall"
            data-testid="truth-of-day-cta"
            className="btn-outline inline-flex items-center gap-2"
          >
            {cta}
          </Link>
        </div>
      </div>
    </section>
  );
}
